"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIMEType = exports.originalMIMETypes = exports.namedExtensions = void 0;
exports.namedExtensions = {
    Image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'],
    PDF: ['pdf'],
    Document: ['doc', 'docx'],
    Video: ['mp4', 'webm', 'avi', 'mov', 'flv', 'wmv', 'mkv'],
    Audio: ['mp3', 'wav', 'ogg'],
    Presentation: ['ppt', 'pptx'],
    Excel: ['xls', 'xlsx'],
};
exports.originalMIMETypes = {
    'audio/*': exports.namedExtensions.Audio,
    'video/*': exports.namedExtensions.Video,
    'image/*': exports.namedExtensions.Image,
};
exports.MIMEType = Object.assign({
    // Virtual MIME type, not real MIME type
    'doc/*': exports.namedExtensions.Document, 'pdf/*': exports.namedExtensions.PDF, 'ppt/*': exports.namedExtensions.Presentation, 'excel/*': exports.namedExtensions.Excel, 'application/vnd.ms-powerpoint': ['ppt'], 'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['pptx']
}, exports.originalMIMETypes);
